import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Camera from './components/CameraWithAddress'

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Camera/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
